import { render } from "./input-editor.vue?vue&type=template&id=67159188"
import script from "./input-editor.vue?vue&type=script&lang=js"
export * from "./input-editor.vue?vue&type=script&lang=js"
script.render = render

export default script